import i18n from "src/i18n/i18n";
import * as Yup from "yup";

export default class Client {
    id: number;
    rfc: string;
    name: string;
    created_at: string;
    updated_at: string;

    static getRules(client: Client) {
        return Yup.object().shape({
            rfc: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .min(12)
                .max(13)
                .matches(/^([A-Z]{3,4})(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))([A-Z\d]{2}(?:[A\d]))?$/, "RFC no válido"),
            name: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(200),
        })
    }

    static getInitValues(client: Client) {
        return {
            rfc: client ? client.rfc : "",
            name: client ? client.name : "",
        }
    }
}
